
<p-table [columns]="tableCols" [value]="masterLists" selectionMode="single" [(selection)]="selectedMasterList"
  (onRowSelect)="onRowSelect($event)" [loading]="loading">
  <ng-template pTemplate="caption">
    {{title}}
  </ng-template>

  <ng-template pTemplate="header" let-columns>
    <tr>
      <th id="{{col.field+'Column'}}" *ngFor="let col of columns"
        [ngStyle]="{'width': col.width ,'display': col.display}"
        [pSortableColumn]="col.field=='lab' ? col.sort:col.field">
        {{col.header}}
        <p-sortIcon [field]="col.field=='lab' ? col.sort:col.field"></p-sortIcon>
      </th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-rowData let-columns="columns">
    <tr [pSelectableRow]="rowData">
      <ng-container *ngFor="let col of columns">
        <td class="wrapword" [ngStyle]="{'display': col.display}" *ngIf="col.field != 'showInMenu' && col.field != 'active' && col.field != 'lab'">
          {{rowData[col.field]=='WELL384'? 384 : rowData[col.field]=='WELL96'? 96 : rowData[col.field]}}
        </td>
        <td *ngIf="col.field == 'active' || col.field == 'showInMenu'">
          <p-checkbox id="active" disabled [(ngModel)]="rowData[col.field]" binary="true"></p-checkbox>
        </td>
        <td *ngIf="col.field == 'lab' ">
          {{rowData[col.field]!= null? rowData[col.field].name :''}}
        </td>
      </ng-container>
    </tr>
  </ng-template>
  <ng-template pTemplate="summary" let-rowData>
    <div class="textAlignment">
      <button type="button" pButton class="h-2rem" icon="pi pi-plus" (click)="showDialogToAddMasterList()" label="Add"></button>
    </div>
  </ng-template>
</p-table>

<p-dialog header="{{title}} Details" position="top" [(visible)]="displayMasterListDialog" [focusOnShow]="false" showEffect="fade" [modal]="true" [style]="{'width':'650px'}"  [baseZIndex]="1000">

  <div *ngIf="masterList">
    <div *ngFor="let col of tableCols">
      <div class="form-group m-2">
        <div *ngIf="col.field != 'mergeInStatus' && col.field != 'statusAfterMerge'">
          <label>{{col.header}}</label>
       </div>
        <div *ngIf="col.field == 'workFlowName'">
          <input pInputText class="form-control" [(ngModel)]="masterList[col.field]" [ngClass]=" { 'disableTextBox' : isWorkFlowName(col.field) }"
            (change)="masterList[col.field]=masterList[col.field].trim()">
        </div>
        <div *ngIf="col.field == 'workflowGroup'">
          <p-dropdown [options]="workFlowGroupOptions" [(ngModel)]="masterList.workflowGroup" filter="true" optionLabel="label"
                    optionValue="value" filterBy="label"
                      placeholder="Select a workflow Group"  [showClear]="true"></p-dropdown>
        </div>
        <div *ngIf="col.field == 'processScale'">
          <div class="processScaleClass">
          <p-dropdown [options]="processScaleOptions" [(ngModel)]="masterList.processScale" filter="true" optionLabel="label"
                    optionValue="value" filterBy="label"
                      placeholder="Select a process scale"  [showClear]="true" (onChange)="displayWell384MergeDropDown(masterList.processScale)"></p-dropdown>
           </div>
          <div *ngIf='well384MergeView' class="merge384Mdm">
            <label style="padding-top: 19px;margin-bottom: 0;">384 Merge</label>
            <div *ngIf="masterList">
            <div *ngFor="let col of tableCols">
                <div class="form-group">
                    <div *ngIf="col.field == 'mergeInStatus' || col.field == 'statusAfterMerge'">
                        <label>{{col.header}}</label>
                    </div>
                    <div *ngIf="col.field == 'mergeInStatus'">
                      <p-dropdown [options]="mergeInStatusOptions" [(ngModel)]="masterList.mergeInStatus" filter="true" optionLabel="label"
                    optionValue="value" filterBy="label" placeholder="Select Merge in status"
                       [showClear]="true"></p-dropdown>
                    </div>

                    <div *ngIf="col.field == 'statusAfterMerge'">
                      <p-dropdown [options]="statusAfterMergeOptions" [(ngModel)]="masterList.statusAfterMerge" filter="true" optionLabel="label"
                    optionValue="value" filterBy="label" placeholder="Select a status after merge"
                       [showClear]="true"></p-dropdown>
                      </div>
                </div>
              </div>
            </div>
            </div>

        </div>

        <div *ngIf="col.field == 'lab'">
          <p-dropdown [options]="labOptions" [(ngModel)]="selectedLab" filter="true" filterBy="label" placeholder="Select a Lab"
            optionLabel="name" [showClear]="true"></p-dropdown>
        </div>

        <div *ngIf="col.field == 'active'">
          <p-checkbox [(ngModel)]="masterList[col.field]" binary="true"></p-checkbox>
        </div>
      </div>
    </div>

  </div>


  <div class="ui-dialog-buttonpane ui-helper-clearfix flex justify-content-end">
    <button type="button" pButton icon="pi pi-check" [disabled]="isSaveDisabled()" (click)="saveMasterListData()"
      label="Save" class="h-2rem"></button>
  </div>
</p-dialog>

<p-blockUI [blocked]="blocked">
  <div>
    <p-progressSpinner [style]="{width: '100px', height: '200px'}" strokeWidth="6"></p-progressSpinner>
  </div>
</p-blockUI>
